export enum SETTINGS_ACTION_TYPES {
    GET_SETTINGS_START = 'settings/GET_SETTINGS_START',
    GET_SETTINGS_SUCCESS = 'settings/GET_SETTINGS_SUCCESS',
    GET_SETTINGS_FAILED = 'settings/GET_SETTINGS_FAILED',
}